/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Photo_FailedInputs */

const en_editor_photo_failed = /** @type {(inputs: Editor_Photo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photo couldn't be uploaded. Try another image.`)
};

const de_editor_photo_failed = /** @type {(inputs: Editor_Photo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Foto konnte nicht hochgeladen werden. Versuch ein anderes Bild.`)
};

/**
* | output |
* | --- |
* | "The photo couldn't be uploaded. Try another image." |
*
* @param {Editor_Photo_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_photo_failed = /** @type {((inputs?: Editor_Photo_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Photo_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_photo_failed(inputs)
	return en_editor_photo_failed(inputs)
});